import React from 'react'

export const PageHeader = ({ pageName, pageNameDescription = '' }) => (
    <div className="app__page-header">
        {pageName} {pageNameDescription && <span className="header-description">{pageNameDescription}</span>}
    </div>
)
